var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 2